module.exports = __webpack_public_path__ + "static/media/ico-lang.b522569f.svg";